module.exports = __webpack_public_path__ + "img/info.257b5c98.svg";